import { MenuItem, MenuItems } from "../@types";
import { pluralize } from "../../utils";
import { NotificationsLevel } from "../../lib/enums";
import { show } from "../../notifications/notifications";
import { isEqual } from "lodash";

export const createSelectTagOption = (option: string): MenuItem => {
  const optionCleaned = option?.trim();
  return {
    label: optionCleaned,
    value: optionCleaned
  };
};

export const formatTagNotificationMessage = (label: string, tags: string[]) => {
  const cleanedTags = tags.filter((tag: string) => tag !== undefined);
  return cleanedTags.length
    ? `${pluralize(label, cleanedTags.length)}: ${cleanedTags.join(", ")}`
    : "No new tags added.";
};

export const checkForEmptySave = (selectedTags: MenuItems) =>
  selectedTags.length === 0;

export const checkForNoChangeOnSave = ({
  selectedTags,
  initialTags
}: {
  selectedTags: MenuItems;
  initialTags: string[];
}) => {
  const selectedTagsList = selectedTags.map(item => item.value);
  const emptyOnStart = initialTags.length === 0;
  const emptyOnSave = selectedTagsList.length === 0;
  return (
    (emptyOnStart && emptyOnSave) ||
    (!emptyOnStart && isEqual(selectedTagsList, initialTags))
  );
};

export const noTagChangeNotification = () => {
  show({
    level: NotificationsLevel.INFO,
    message: "No new tags added."
  });
};
